import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Image from '../AppImage';
import Button from './Button';
import { useAuth } from '../../utils/AuthContext';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();

  const navigationItems = [
    { name: 'Home', path: '/homepage', icon: 'Home' },
    { name: 'Search Properties', path: '/property-search-discovery', icon: 'Search' },
    // { name: 'Neighborhoods', path: '/neighborhood-intelligence-hub', icon: 'MapPin' },
    // { name: 'Dashboard', path: '/user-dashboard', icon: 'LayoutDashboard' },
    { name: 'Owner Portal', path: '/owner-portal', icon: 'Building' },
  ];

  const isActivePath = (path) => location.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleSignIn = () => {
    navigate('/login', { state: { from: location.pathname } });
  };

  const handleSignOut = () => {
    logout();
    if (location.pathname.startsWith('/owner-portal')) {
      navigate('/homepage');
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-surface border-b border-border shadow-property-card">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/homepage" className="flex items-center space-x-2 hover:opacity-80 transition-quick">
            <Image
              src="/assets/images/logo.jpg"
              alt="Power House Logo"
              className="h-8 w-auto"
            />
            <span className="text-xl font-bold text-text-primary">Power House</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-smooth ${
                  isActivePath(item.path)
                    ? 'bg-primary text-primary-foreground'
                    : 'text-text-secondary hover:text-text-primary hover:bg-muted'
                }`}
              >
                <Icon name={item.icon} size={16} />
                <span>{item.name}</span>
              </Link>
            ))}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center space-x-3 pr-4">
           {/* <Button variant="ghost" size="sm" iconName="Heart" iconPosition="left">
              Saved
            </Button>
            <Button variant="ghost" size="sm" iconName="MessageCircle" iconPosition="left">
              Messages
            </Button> */}
            {isAuthenticated ? (
              <Button variant="outline" size="sm" iconName="LogOut" iconPosition="left" onClick={handleSignOut}>
                Sign Out
              </Button>
            ) : (
              <Button variant="outline" size="sm" iconName="User" iconPosition="left" onClick={handleSignIn}>
                Sign In
              </Button>
            )}
            {/*<Button variant="default" size="sm" iconName="Plus" iconPosition="left">
              List Property
            </Button> */}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 rounded-lg text-text-secondary hover:text-text-primary hover:bg-muted transition-quick"
            aria-label="Toggle mobile menu"
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-border bg-surface">
            <nav className="px-4 py-4 space-y-2">
              {navigationItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`flex items-center space-x-3 px-3 py-3 rounded-lg text-sm font-medium transition-smooth ${
                    isActivePath(item.path)
                      ? 'bg-primary text-primary-foreground'
                      : 'text-text-secondary hover:text-text-primary hover:bg-muted'
                  }`}
                >
                  <Icon name={item.icon} size={18} />
                  <span>{item.name}</span>
                </Link>
              ))}
            </nav>
            
            {/* Mobile Actions */}
            <div className="px-4 pb-4 space-y-2 border-t border-border pt-4">
              <Button variant="ghost" fullWidth iconName="Heart" iconPosition="left">
                Saved Properties
              </Button>
              <Button variant="ghost" fullWidth iconName="MessageCircle" iconPosition="left">
                Messages
              </Button>
              {isAuthenticated ? (
                <Button variant="outline" fullWidth iconName="LogOut" iconPosition="left" onClick={() => { setIsMobileMenuOpen(false); handleSignOut(); }}>
                  Sign Out
                </Button>
              ) : (
                <Button variant="outline" fullWidth iconName="User" iconPosition="left" onClick={() => { setIsMobileMenuOpen(false); handleSignIn(); }}>
                  Sign In
                </Button>
              )}
              <Button variant="default" fullWidth iconName="Plus" iconPosition="left">
                List Your Property
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;